export const state = {
  applicationSubmissionApi: null,
  bearerToken: null,
  brand: null,
  emailAddress: null,
  favicon: null,
  footerLogo: {
    alt: null,
    height: null,
    src: null,
    width: null
  },
  headerLogo: {
    alt: null,
    height: null,
    src: null,
    width: null
  },
  leadChannel: null,
  mailCodeSource: null,
  name: null,
  organizationCode: null,
  phoneNumber: null,
  stylesheet: null,
  workflow: null
};
